import tinycolor from 'tinycolor2';
import { cellTextColor } from '../../../utils/tableStyles';

// Seuil AA du WCAG pour un texte courant.
export const MIN_CONTRAST = 4.5;

// Fond semi-transparent : il est vu par-dessus la page blanche. Sans ce
// mélange, un fond noir à 10 % compterait comme du noir.
const opaqueBackground = (color) => {
  const background = tinycolor(color);
  const alpha = background.getAlpha();
  return alpha < 1
    ? tinycolor.mix('#ffffff', background.setAlpha(1), alpha * 100)
    : background;
};

/**
 * Plus faible rapport de contraste entre un texte et les fonds qu'il peut
 * avoir, arrondi au dixième. `null` si une couleur manque ou n'est pas lisible.
 */
export const lowestContrast = (textColor, backgroundColors) => {
  const text = tinycolor(textColor);
  if (!textColor || !text.isValid()) return null;
  if (backgroundColors.some((color) => !color || !tinycolor(color).isValid())) return null;

  const ratios = backgroundColors.map((color) => tinycolor.readability(text, opaqueBackground(color)));
  return Math.round(Math.min(...ratios) * 10) / 10;
};

// Mêmes couleurs que le rendu de l'en-tête (cf. getHeaderStyle).
export const headerContrast = (tableStyle) =>
  lowestContrast(
    tableStyle?.customHeaderTextColor?.style,
    [tableStyle?.customHeaderColor?.style ?? '#fafafa']
  );

// Mêmes couleurs que le rendu des cellules (cf. getCellStyle) : zébré, chaque
// ligne doit se lire avec son texte sur son fond.
export const cellsContrast = (tableStyle) => {
  if (!tableStyle?.stripped1) {
    return lowestContrast(cellTextColor(tableStyle, true), [tableStyle?.customCellColor?.style]);
  }
  const ratios = [
    lowestContrast(cellTextColor(tableStyle, true), [tableStyle.strippedCustomClr1?.style]),
    lowestContrast(cellTextColor(tableStyle, false), [tableStyle.strippedCustomClr2?.style]),
  ];
  return ratios.includes(null) ? null : Math.min(...ratios);
};
